'use client';

import { useEffect, useState } from 'react';
import { checkLetterAvatar, realPhoto } from '@/lib/placeholder-photo';

/**
 * The picture to show for a person, or '' when it's only a placeholder — an
 * initials picture we generated, or Google's default letter avatar (checked in
 * the browser once per URL). '' means: show the BB vector art.
 */
export function useRealPhoto(url?: string | null): string {
  const photo = realPhoto(url);
  const [letter, setLetter] = useState<string | null>(null);
  useEffect(() => {
    if (!photo || !/googleusercontent\.com\//.test(photo)) return;
    let alive = true;
    checkLetterAvatar(photo).then(isLetter => { if (alive && isLetter) setLetter(photo); });
    return () => { alive = false; };
  }, [photo]);
  return photo && photo !== letter ? photo : '';
}
